import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "sonner";

function GoogleBtn({ onClick }) {
    return (
        <button data-testid="google-login" onClick={onClick} type="button" className="w-full border border-[#E8DFD5] bg-white py-3 text-sm flex items-center justify-center gap-2 hover:bg-cream-soft transition-colors">
            <svg className="h-4 w-4" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
            Continue with Google
        </button>
    );
}

export function AuthShell({ title, children }) {
    return (
        <div className="mx-auto max-w-md px-5 py-16">
            <div className="text-center mb-8">
                <Link to="/" className="font-serif text-3xl tracking-[0.28em]">ELVOSH</Link>
                <p className="eyebrow mt-4">{title}</p>
            </div>
            {children}
        </div>
    );
}

export default function Login() {
    const { login, startGoogleLogin } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Welcome back!");
            navigate("/account");
        } catch (err) {
            toast.error(apiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthShell title="Welcome Back">
            <form onSubmit={submit} className="space-y-4">
                <input data-testid="login-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-white border border-[#E8DFD5] px-4 py-3 text-sm outline-none focus:border-gold" />
                <input data-testid="login-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-white border border-[#E8DFD5] px-4 py-3 text-sm outline-none focus:border-gold" />
                <div className="text-right"><Link to="/forgot-password" className="text-xs text-gold hover:underline">Forgot password?</Link></div>
                <button data-testid="login-submit" disabled={loading} className="w-full bg-ink text-cream py-3 text-sm uppercase tracking-[0.15em] hover:bg-gold transition-colors disabled:opacity-50">{loading ? "Signing in…" : "Sign In"}</button>
            </form>
            <div className="flex items-center gap-3 my-5 text-xs text-muted-foreground"><span className="flex-1 h-px bg-[#E8DFD5]" />OR<span className="flex-1 h-px bg-[#E8DFD5]" /></div>
            <GoogleBtn onClick={startGoogleLogin} />
            <p className="text-center text-sm text-muted-foreground mt-6">New to ELVOSH? <Link to="/register" className="text-gold hover:underline">Create an account</Link></p>
        </AuthShell>
    );
}

export { GoogleBtn };
